import { createFileRoute } from "@tanstack/react-router";
import AddAssessments from "@/features/assessments/pages/add-assessments/AddAssessments";

export const Route = createFileRoute("/$locale/$partner/add-assessments")({
	component: AddAssessments,
});
